const ACCESS_FROM = {
  BACK_BUTTON: 'backButton',
  BRAND_LOGO: 'brandLogo',
  BREADCRUMB: 'breadcrumb',
  NAVIGATION: 'navigation',
  NEXT: 'next',
  PREVIOUS: 'previous',
  PRODUCT_ITEM: 'productItem',
  REJECTION_MODAL: 'rejectionModal',
  SEE_ALL_PRODUCT: 'seeAllProduct'
}

const MIXPANEL_ACCESS_MAP = {
  [ACCESS_FROM.BACK_BUTTON]: 'Arborescence',
  [ACCESS_FROM.BRAND_LOGO]: 'Arborescence',
  [ACCESS_FROM.BREADCRUMB]: 'Breadcrumb',
  [ACCESS_FROM.NAVIGATION]: 'Arborescence',
  [ACCESS_FROM.NEXT]: 'Next',
  [ACCESS_FROM.PREVIOUS]: 'Previous',
  [ACCESS_FROM.PRODUCT_ITEM]: 'Catalog Page',
  [ACCESS_FROM.REJECTION_MODAL]: 'Product Page',
  [ACCESS_FROM.SEE_ALL_PRODUCT]: 'Arborescence'
}

const MIXPANEL_APP_NAME = 'TSF'

export { ACCESS_FROM, MIXPANEL_ACCESS_MAP, MIXPANEL_APP_NAME }
